import { VIEW } from "@/constants/tabs";
import { SUB_TAB } from "@/constants/tabs";
import type { ActiveView } from "@/constants/tabs";
import type { ActiveSubTab } from "@/constants/tabs";

export const QUERY_PARAM = {
    tab: "tab",
} as const;

export const ROUTE_PATH = {
    home: "/",
    notFound: "/404",
    error: "/error",
    forbidden: "/forbidden",
    dashboard: "/dashboard",
    approval: "/approval",
    users: "/users",
    groups: "/groups",
    categories: "/categories",
    policyExceptions: "/policy/exceptions",
    policyMileage: "/policy/mileage",
    policyCurrency: "/policy/currency",
    policyHotel: "/policy/hotel",
    policyReceipt: "/policy/receipt",
    permissions: "/permissions",
} as const;

const PATH_TO_VIEW: Record<string, ActiveView> = {
    [ROUTE_PATH.home]: VIEW.Dashboard,
    [ROUTE_PATH.dashboard]: VIEW.Dashboard,
    [ROUTE_PATH.approval]: VIEW.Approval,
    [ROUTE_PATH.users]: VIEW.Users,
    [ROUTE_PATH.groups]: VIEW.Groups,
    [ROUTE_PATH.categories]: VIEW.Categories,
    [ROUTE_PATH.policyExceptions]: VIEW.PolicyExceptions,
    [ROUTE_PATH.policyMileage]: VIEW.PolicyMileage,
    [ROUTE_PATH.policyCurrency]: VIEW.PolicyCurrency,
    [ROUTE_PATH.policyHotel]: VIEW.PolicyHotel,
    [ROUTE_PATH.policyReceipt]: VIEW.PolicyReceipt,
    [ROUTE_PATH.permissions]: VIEW.Permissions,
};

export const VIEW_TO_ROUTE: Record<ActiveView, string> = {
    [VIEW.Dashboard]: ROUTE_PATH.dashboard,
    [VIEW.Approval]: `${ROUTE_PATH.approval}?${QUERY_PARAM.tab}=${SUB_TAB.Review}`,
    [VIEW.Users]: ROUTE_PATH.users,
    [VIEW.Groups]: ROUTE_PATH.groups,
    [VIEW.Categories]: ROUTE_PATH.categories,
    [VIEW.PolicyExceptions]: ROUTE_PATH.policyExceptions,
    [VIEW.PolicyMileage]: ROUTE_PATH.policyMileage,
    [VIEW.PolicyCurrency]: ROUTE_PATH.policyCurrency,
    [VIEW.PolicyHotel]: ROUTE_PATH.policyHotel,
    [VIEW.PolicyReceipt]: ROUTE_PATH.policyReceipt,
    [VIEW.Permissions]: ROUTE_PATH.permissions,
};

export function getActiveViewFromPath(pathname: string): ActiveView | null {
    // Exact match first
    if (PATH_TO_VIEW[pathname]) return PATH_TO_VIEW[pathname];

    // Sub-path match: e.g. /approval/unknown → Approval
    for (const [route, view] of Object.entries(PATH_TO_VIEW)) {
        if (route !== "/" && pathname.startsWith(`${route}/`)) return view;
    }

    return null;
}

const VALID_APPROVAL_TABS = new Set<ActiveSubTab>([SUB_TAB.Preview, SUB_TAB.Review, SUB_TAB.Completed]);

export function isValidApprovalTab(value: string | null): value is ActiveSubTab {
    return value !== null && VALID_APPROVAL_TABS.has(value as ActiveSubTab);
}

export const SUB_TAB_TO_ROUTE: Record<ActiveSubTab, string> = {
    [SUB_TAB.Preview]: `${ROUTE_PATH.approval}?${QUERY_PARAM.tab}=${SUB_TAB.Preview}`,
    [SUB_TAB.Review]: `${ROUTE_PATH.approval}?${QUERY_PARAM.tab}=${SUB_TAB.Review}`,
    [SUB_TAB.Completed]: `${ROUTE_PATH.approval}?${QUERY_PARAM.tab}=${SUB_TAB.Completed}`,
};

export function getApprovalSubTabFromSearch(search: string): ActiveSubTab {
    const params = new URLSearchParams(search);
    const value = params.get(QUERY_PARAM.tab);

    if (isValidApprovalTab(value)) {
        return value as ActiveSubTab;
    }

    return SUB_TAB.Review;
}
